import { ICourse } from "../models/get-course.model.";
import { COURSE_IMAGES } from "../util/constants/COURSE_IMAGENS";

export const listCoursesAdapter = (courses: ICourse[]) => {
    return {
        data: courses.map(course => {
            const courseImage = COURSE_IMAGES.find(item => item.path === course.route)
            return {
                id: course.id,
                name: course.name,
                description: course.description,
                path: course.route,
                score: course.min_score,
                bonus: course.bonus,
                image: courseImage?.image
            }
        })
    }
}